// AI Generated Component
import { Component, Input } from '@angular/core';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';

@Component({
    standalone: false,
    selector: 'form-global-policy-element',
    template: `
<div class="col-48">
    <div class="row">
        <div class="col-48 pt-4">
            <strong translate>Drag and drop the rule to add rules to the policy</strong>
        </div>
    </div>
    <div class="row d-flex flex-wrap align-items-stretch policy-boxes-element">
        <div *ngFor="let element of elements; trackBy: trackByIndex; let index = index" class="col-16 rule-wrapper outer-t-small outer-b-small">
            <button
                type="button"
                [id]="'rule-button-' + index"
                draggable="true"
                (dragstart)="onDragStart($event, element)"
                (dragend)="onDragEnd($event)"
                [class.dragging]="draggedElement === element">
                <span class="col-48 px-0 py-4 btn btn-border-radius btn-grey icon-btn">
                    <span ngbTooltip="{{ element.description | translate }}"
                          [attr.aria-label]="element.description | translate"
                          [triggers]="'focus hover'"
                          placement="top"
                          class="fas fa-question-circle cursor-pointer desc-tooltip mt-2 mr-2"
                          [container]="'body'"
                          aria-hidden="true">
                    </span>
                    <span *ngFor="let icon of element.icons"
                        class="main-1-color outer-l-mini outer-r-mini {{icon}}">
                    </span>
                    <br/>
                    <span>{{element.translation}}</span>
                </span>
            </button>
        </div>
    </div>
</div>
    `,
})
export class FormGlobalPolicyElementComponent {
    @Input() policy: any;
    @Input() elements: any;

    draggedElement: any = null;

    constructor (private monEventService: MonEventService) {}

    trackByIndex (index: number): number {
        return index;
    }

    onDragStart (event: DragEvent, element: any): void {
        this.draggedElement = element;

        // Set drag data
        const dragData = {
            type: element.type,
            translation: element.translation,
            icons: element.icons,
        };
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'copy';
            event.dataTransfer.setData('application/json', JSON.stringify(dragData));
            // Notify other components
            this.monEventService.run('dragStart', { element });
            this.monEventService.run('scrollToDropzone');
        }

    }

    onDragEnd (event: DragEvent): void {
        this.draggedElement = null;
        this.monEventService.run('dragEnd');
    }
}
